import { useLocation } from "react-router-dom";

import { SearchResultsResponse } from "@/api";
import { ContentThumbnail, ContentTitle, Grid } from "@/components";
import { useNavigateToItem } from "@/hooks";
import { cn, getContentThumbnailUrl } from "@/utils";
import { ITEM_TYPE_COLLECTION, ITEM_TYPE_VIDEO } from "@/const.ts";
import { useTranslate } from "@/providers/context";

type SearchResultsProps = {
  total: number;
} & SearchResultsResponse;

export const SearchResults = ({
  videos,
  collections,
  total,
}: SearchResultsProps) => {
  const { navigateToItem } = useNavigateToItem();
  const { translate } = useTranslate();
  const location = useLocation();

  const resultLabel = total !== 1 ? translate("Results") : translate("Result");

  return (
    <>
      {total > 0 && (
        <div className="h5-bold mb-[12px] py-[7px]">{`${total} ${resultLabel}`}</div>
      )}
      <Grid>
        {videos?.map((v) => {
          return (
            <div key={v.VideoId}>
              <div className="aspect-video w-full">
                <ContentThumbnail
                  className={cn(["w-full cursor-pointer rounded-[8px]"])}
                  thumbnail={getContentThumbnailUrl(v, "medium")}
                  contentItem={v}
                  onClick={() =>
                    navigateToItem({
                      item: {
                        ChildId: v.VideoId.toString(),
                        Type: ITEM_TYPE_VIDEO,
                      },
                    })
                  }
                />
              </div>
              <ContentTitle title={v.Title} />
            </div>
          );
        })}
        {collections?.map((c) => {
          return (
            <div key={c.TabId}>
              <div className="aspect-video w-full">
                <ContentThumbnail
                  className={cn(["w-full cursor-pointer rounded-[8px]"])}
                  thumbnail={
                    c.Thumbnails["medium"] ?? c.Thumbnails["source"] ?? ""
                  }
                  contentItem={c}
                  onClick={() =>
                    navigateToItem({
                      item: {
                        ChildId: c.TabId.toString(),
                        Type: ITEM_TYPE_COLLECTION,
                      },
                      state: { fromQuery: location.search },
                    })
                  }
                />
              </div>
              <ContentTitle title={c.Name} />
            </div>
          );
        })}
      </Grid>
    </>
  );
};
